import SampleProductsPage from "../../features/sample-products/sample-products-page";

// import "../../styles/scss/products.scss";
export default function SampleProducts() {
  return <SampleProductsPage />;
}
